/** True when the file-server databank download API indicates the file is missing. */
export function isDatabankDownloadNotFoundError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }

  const err = error as { status?: number; error?: { code?: string } };
  return err.status === 404 || err.error?.code === 'RESOURCE_NOT_FOUND';
}
